(function ($) {
  $.fn.highlightCardsSlickSlider = function () {
    var $sliders = this;

    function initializeSlider($slider) {
      var $container = $slider.parents(".c-scroll-shelf").siblings(".c-hightlights-header").find('.c-highlight__slider');
      var $pageStatus = $container.find('.page__status');

      // Initialize Slick only if not initialized
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true,
          prevArrow: $container.find('.previous__arrow'),
          nextArrow: $container.find('.next__arrow'),
          touchThreshold: 20,
          responsive: [
            {
              breakpoint: 1025,
              settings: "unslick"
            }
          ]
        });

        // Update page status
        function updatePageStatus(slick, currentSlide) {
          var current = (currentSlide ? currentSlide : 0) / slick.options.slidesToScroll + 1;
          var total = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
          $pageStatus.text(current + ' / ' + total);
        }

        // Events to update page status
        $slider.on('init afterChange', function (event, slick, currentSlide) {
          updatePageStatus(slick, currentSlide);
        });

        // Trigger init event for initial page status
        $slider.on('init', function (event, slick) {
          updatePageStatus(slick, 0);
        });

        // Refresh Slick to avoid glitches
        $slider.slick('setPosition');
      }
    }

    // Initialize sliders initially
    $sliders.each(function () {
      initializeSlider($(this));
    });

    // Handle resize to reinitialize Slick when screen goes above 1025px
    var resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        $sliders.each(function () {
          var $slider = $(this);
          if ($(window).width() >= 1025) {
            initializeSlider($slider);
          }
        });
      }, 200);
    });

    return this;
  };
})(jQuery);